module.exports = __webpack_public_path__ + "img/5s.4856e2bd.png";